import React from 'react'

export default function CalendarEnabledIcon(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      {...props}
    >
      <path
        d='M7.3 10.2987L9.61667 7.98203C9.75 7.8487 9.91111 7.78203 10.1 7.78203C10.2889 7.78203 10.45 7.8487 10.5833 7.98203C10.7167 8.11536 10.7833 8.27647 10.7833 8.46536C10.7833 8.65425 10.7167 8.81536 10.5833 8.9487L7.76667 11.7654C7.63333 11.8987 7.47778 11.9654 7.3 11.9654C7.12222 11.9654 6.96667 11.8987 6.83333 11.7654L5.41667 10.3487C5.28333 10.2154 5.21667 10.0543 5.21667 9.86536C5.21667 9.67648 5.28333 9.51536 5.41667 9.38203C5.55 9.2487 5.71111 9.18203 5.9 9.18203C6.08889 9.18203 6.25 9.2487 6.38333 9.38203L7.3 10.2987ZM3.33333 14.6654C2.96667 14.6654 2.65278 14.5348 2.39167 14.2737C2.13056 14.0126 2 13.6987 2 13.332V3.9987C2 3.63203 2.13056 3.31814 2.39167 3.05703C2.65278 2.79592 2.96667 2.66536 3.33333 2.66536H4V1.9987C4 1.80981 4.06389 1.65148 4.19167 1.5237C4.31944 1.39592 4.47778 1.33203 4.66667 1.33203C4.85556 1.33203 5.01389 1.39592 5.14167 1.5237C5.26944 1.65148 5.33333 1.80981 5.33333 1.9987V2.66536H10.6667V1.9987C10.6667 1.80981 10.7306 1.65148 10.8583 1.5237C10.9861 1.39592 11.1444 1.33203 11.3333 1.33203C11.5222 1.33203 11.6806 1.39592 11.8083 1.5237C11.9361 1.65148 12 1.80981 12 1.9987V2.66536H12.6667C13.0333 2.66536 13.3472 2.79592 13.6083 3.05703C13.8694 3.31814 14 3.63203 14 3.9987V13.332C14 13.6987 13.8694 14.0126 13.6083 14.2737C13.3472 14.5348 13.0333 14.6654 12.6667 14.6654H3.33333ZM3.33333 13.332H12.6667V6.66536H3.33333V13.332ZM3.33333 5.33203H12.6667V3.9987H3.33333V5.33203Z'
        fill='currentColor'
      />
    </svg>
  )
}
